import React, { createContext, useState, useCallback, useMemo } from 'react';

// Create the context
const FilterContext = createContext();

// Create a provider component
export const FilterProvider = ({ initialValue = [], onFilterChange = () => {}, children }) => {
  const [filters, setFilters] = useState(initialValue);

  const changeFilters = useCallback(
    (newFilters) => {
      setFilters(newFilters);
      onFilterChange();
    },
    [setFilters, onFilterChange]
  );

  const setFilter = useCallback(
    (filter) => {
      changeFilters((prevFilters) => [
        ...prevFilters.filter((f) => f.key() !== filter.key()),
        filter,
      ]);
    },
    [changeFilters]
  );

  const resetFilters = useCallback(() => {
    changeFilters([]);
  }, [changeFilters]);

  const resetFilterByKey = useCallback(
    (filterKey) => {
      changeFilters((prevFilters) => prevFilters.filter((f) => f.key() !== filterKey));
    },
    [changeFilters]
  );

  const resetFilter = useCallback(
    (filter) => {
      resetFilterByKey(filter.key());
    },
    [resetFilterByKey]
  );

  const filterValue = useMemo(
    () => ({ filters, setFilter, resetFilters, resetFilter, resetFilterByKey }),
    [filters, setFilter, resetFilter, resetFilters, resetFilterByKey]
  );

  return <FilterContext.Provider value={filterValue}>{children}</FilterContext.Provider>;
};

export default FilterContext;
